// extracted by mini-css-extract-plugin
export var dateLabel = "_4e-0";
export var dateLabelError = "_4e-1";
export var fullWidth = "_4e-2";
export var smaller = "_4e-3";